import { gql } from "@apollo/client/core";

export const GROUP_ORDER_FIELDS = `
  _id label status shareToken repFirstName customerId customerName customerEmail
  street suit city state zip locationName placeId lat lng
  deliveryDate deliveryTime timeZone headCount maxHeadCount
  totalBudget perPersonBudget perPersonTotal subtotal estimatedTotal overBudgetBy overBudgetReason
  contactPerson contactNo instruction driverTip driverTipType tipPercentage tablewareDeclined
  catererId catererSlug catererName cartDetailsJson version
  orderId placedAt updatedOn createdOn itemsUpdatedAt readyAt readyByKind
`;

// Lists don't need the cart lines.
export const GROUP_ORDER_LIST_FIELDS = `
  _id label status shareToken customerName customerEmail street city deliveryDate headCount maxHeadCount
  totalBudget perPersonBudget subtotal estimatedTotal overBudgetBy overBudgetReason catererId catererName
  orderId placedAt updatedOn createdOn itemsUpdatedAt readyAt readyByKind
`;

export const GROUP_ORDER_BY_TOKEN = gql`
  query GroupOrderByToken($token: String!) { groupOrderByToken(token: $token) { ${GROUP_ORDER_FIELDS} } }`;
export const MY_GROUP_ORDERS = gql`
  query MyGroupOrders { myGroupOrders { ${GROUP_ORDER_LIST_FIELDS} } }`;
export const GROUP_ORDER = gql`
  query GroupOrder($id: ID!) { groupOrder(id: $id) { ${GROUP_ORDER_FIELDS} } }`;
export const ADMIN_GROUP_ORDERS = gql`
  query AdminGroupOrders($search: String, $status: [String], $skip: Int, $limit: Int) {
    adminGroupOrders(search: $search, status: $status, skip: $skip, limit: $limit) { count data { ${GROUP_ORDER_LIST_FIELDS} } } }`;
export const ADMIN_GROUP_ORDER = gql`
  query AdminGroupOrder($id: ID!) { adminGroupOrder(id: $id) { ${GROUP_ORDER_FIELDS} } }`;

export const CREATE_GROUP_ORDER = gql`
  mutation CreateGroupOrder($input: GroupOrderSettingsInput!) { createGroupOrder(input: $input) { ${GROUP_ORDER_FIELDS} } }`;
export const UPDATE_GROUP_ORDER_SETTINGS = gql`
  mutation UpdateGroupOrderSettings($id: ID!, $input: GroupOrderSettingsInput!) { updateGroupOrderSettings(id: $id, input: $input) { ${GROUP_ORDER_FIELDS} } }`;
export const FINISH_GROUP_ORDER = gql`
  mutation FinishGroupOrder($token: String!, $version: Int!) { finishGroupOrder(token: $token, version: $version) { ${GROUP_ORDER_FIELDS} } }`;
export const REOPEN_GROUP_ORDER_FOR_OFFICE = gql`
  mutation ReopenGroupOrderForOffice($token: String!) { reopenGroupOrderForOffice(token: $token) { ${GROUP_ORDER_FIELDS} } }`;
export const ADMIN_SUBMIT_GROUP_ORDER = gql`
  mutation AdminSubmitGroupOrder($id: ID!) { adminSubmitGroupOrder(id: $id) { ${GROUP_ORDER_FIELDS} } }`;
export const SAVE_GROUP_CART_BY_TOKEN = gql`
  mutation SaveGroupCartByToken($token: String!, $cart: GroupOrderCartInput!) { saveGroupCartByToken(token: $token, cart: $cart) { ${GROUP_ORDER_FIELDS} } }`;
export const SAVE_GROUP_CART = gql`
  mutation SaveGroupCart($id: ID!, $cart: GroupOrderCartInput!) { saveGroupCart(id: $id, cart: $cart) { ${GROUP_ORDER_FIELDS} } }`;
export const CANCEL_GROUP_ORDER = gql`
  mutation CancelGroupOrder($id: ID!) { cancelGroupOrder(id: $id) { ${GROUP_ORDER_FIELDS} } }`;
export const START_GROUP_CHECKOUT = gql`
  mutation StartGroupCheckout($id: ID!) { startGroupCheckout(id: $id) { ${GROUP_ORDER_FIELDS} } }`;
export const REOPEN_GROUP_ORDER = gql`
  mutation ReopenGroupOrder($id: ID!) { reopenGroupOrder(id: $id) { ${GROUP_ORDER_FIELDS} } }`;
